import { Component, type ErrorInfo, type ReactNode } from 'react';

type Props = { children: ReactNode };

type State = { error: Error | null };

/**
 * Blokuje „biały ekran” po błędzie renderu w trasach pod dashboardem —
 * użytkownik może przeładować stronę zamiast tracić całą sesję UI.
 */
export default class DashboardRouteErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  override componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('Dashboard route error:', error, info.componentStack);
  }

  override render() {
    if (this.state.error) {
      return (
        <div className="container py-5">
          <h2 className="h4 mb-3">Something went wrong</h2>
          <p className="text-body-secondary small mb-4 font-monospace">
            {this.state.error.message}
          </p>
          <button
            type="button"
            className="btn btn-primary"
            onClick={() => window.location.reload()}
          >
            Reload page
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
